/**
 * PaymentStripe — la franja de pagament de la card (`plans/calendar-card-signals.md` §6 F1.2, D1-D2).
 *
 * 8 px, just després de la barra del canal i sense separació. `NONE` (pagada o cobrada per l'OTA) no
 * pinta res: si no hi ha color, no hi ha feina. El color surt de `signal-styles.ts` i el `title`, del
 * `reason` que calcula el backend.
 */

import type { BookingSignals } from '@guilleumes/types';
import { PAYMENT_STRIPE_STYLES, PAYMENT_STRIPE_WIDTH } from './signal-styles';

export interface PaymentStripeProps {
  payment: BookingSignals['payment'];
}

export function PaymentStripe({ payment }: PaymentStripeProps) {
  if (payment.stripe === 'NONE') return null;
  const style = PAYMENT_STRIPE_STYLES[payment.stripe];
  if (!style) return null;
  return (
    <div
      role="img"
      className="flex-shrink-0"
      style={{ width: PAYMENT_STRIPE_WIDTH, background: style.background }}
      title={payment.reason}
      aria-label={payment.reason}
      data-payment-stripe={payment.stripe}
    />
  );
}

export default PaymentStripe;
